export const mockFaq = [
  {
    id: 1,
    question: '無料体験レッスンはありますか？',
    answer: 'はい、ございます。無料体験レッスンは随時受け付けております。お電話またはお問い合わせフォームからお気軽にお申し込みください。体験レッスンでは、実際のレッスンの雰囲気を感じていただき、講師との相性やレベルチェックも行います。'
  },
  {
    id: 2,
    question: '月謝の支払い方法はどのようなものがありますか？',
    answer: '月謝のお支払いは、銀行振込、口座振替、クレジットカード決済の3つの方法からお選びいただけます。口座振替をご希望の場合は、入会時にお手続きをお願いいたします。お支払いは毎月月末締めの翌月10日引き落としとなります。'
  },
  {
    id: 3,
    question: '振替レッスンは可能ですか？',
    answer: '可能です。やむを得ない事情でレッスンを欠席される場合、レッスン開始の2時間前までにご連絡いただければ、同じ月内での振替レッスンを承ります。ただし、振替可能な回数は月2回までとさせていただいております。'
  },
  {
    id: 4,
    question: '駐車場はありますか？',
    answer: '教室専用の駐車場を10台分ご用意しております。お車でお越しの際は、受付にお声かけください。満車の場合は、近隣のコインパーキングをご利用いただき、駐車券をお持ちいただければ料金を一部負担させていただきます。'
  },
  {
    id: 5,
    question: 'オンラインレッスンの受講に必要な環境は？',
    answer: 'インターネット環境とパソコンまたはタブレット、スマートフォンがあれば受講可能です。推奨環境として、安定したWi-Fi接続、カメラ・マイク機能、Zoomアプリのインストールをお願いしております。初回レッスン前に接続テストも行いますのでご安心ください。'
  },
  {
    id: 6,
    question: 'クラス人数は何名程度ですか？',
    answer: 'グループレッスンは最大6名までの少人数制となっております。キッズクラスは4名まで、大人のクラスは6名までとし、一人ひとりに十分な発話機会を確保しています。よりきめ細かい指導をご希望の方には、マンツーマンレッスンもご用意しております。'
  }
];